module.exports = __webpack_public_path__ + "fonts/Baskerville.d8b9378b.woff";